<template>
  <b-row>
    <b-col cols="12" md="12" lg="6">
    <div
        :key="$store.getters['resource/currentResource'].key"
        class="white-container">
      <loader v-if="loading"/>
      <form-fields
          v-else
          @submit="createResource"
          :formColumns="12"
          class="px-2"
          :fields="fields"
          :labelBlockWith="4"
          :inline="true"
          :mb="4"
      />
    </div>
  </b-col>
</b-row>
</template>


<script>
import FormFields from "../../components/global/formBuilder";
import fields from "./partnersResourceFields"
import i18n from "../../utils/i18n";
export default {
  name: "PartnersResourceCreate",
  components: {FormFields},
  data () {
    return {
      fields: fields.items,
      loading: false
    }
  },

  mounted () {
    this.getPricingPlansOptions()
  },

  methods: {
    async getPricingPlansOptions () {
      this.loading = true
      await this.getData('pricing/plans')
          .then(({data}) => {
            this.fields.map(item => {
              if (item.label === i18n.t('login.wallkit_pricing_plan')) {
                item.options = data.items
              }
            })
          })
          .catch(error => {
            console.log('get pricing plans error', error)
          })
      this.loading = false
    },
    async createResource (params) {
      await this.postData(`partners/${this.$route.params.id}/resources`, {
        ...params,
        pricing_plans_id: params.pricing_plan.id
      })
      .then(() => {
        this.$router.push(`/partners/edit/${this.$route.params.id}`)
      })
      .catch(error => {
        console.log('create resource error', error)
      })
    }
  }

}
</script>
